/**
 * @fileoverview This file is generated by the Angular 2 template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties}
 */
 /* tslint:disable */

import * as import0 from '../../../../../public/upgrade/feature/audit/audit.component';
import * as import1 from '@angular/core/src/linker/view';
import * as import2 from '@angular/core/src/render/api';
import * as import3 from '@angular/core/src/linker/view_utils';
import * as import4 from '@angular/core/src/metadata/view';
import * as import5 from '../../../../../public/upgrade/feature/audit/audit.service';
import * as import6 from '@angular/core/src/linker/view_type';
import * as import7 from '@angular/core/src/change_detection/constants';
import * as import8 from '@angular/core/src/linker/component_factory';
import * as import9 from '@angular/http/src/http';
import * as import10 from '@ngx-translate/core/src/translate.service';
import * as import11 from '../../../../../public/upgrade/feature/audit/audit-filter/audit-filter.component';
import * as import12 from './audit-filter/audit-filter.component.ngfactory';
import * as import13 from '@angular/core/src/linker/view_container';
import * as import14 from '../../../../../public/upgrade/feature/audit/audit-list/audit-list.component';
import * as import15 from './audit-list/audit-list.component.ngfactory';
import * as import16 from '../../../../node_modules/@angular/common/src/directives/ng_if.ngfactory';
import * as import17 from '@ngx-translate/core/src/translate.pipe';
import * as import18 from '@angular/core/src/change_detection/change_detection_util';
import * as import19 from '@angular/core/src/linker/template_ref';
import * as import20 from '@angular/common/src/directives/ng_if';
export class Wrapper_AuditComponent {
  /*private*/ _eventHandler:Function;
  context:import0.AuditComponent;
  /*private*/ _changed:boolean;
  constructor(p0:any,p1:any) {
    this._changed = false;
    this.context = new import0.AuditComponent(p0,p1);
  }
  ngOnDetach(view:import1.AppView<any>,componentView:import1.AppView<any>,el:any):void {
  }
  ngOnDestroy():void {
  }
  ngDoCheck(view:import1.AppView<any>,el:any,throwOnChange:boolean):boolean {
    var changed:any = this._changed;
    this._changed = false;
    if (!throwOnChange) { if ((view.numberOfChecks === 0)) { this.context.ngOnInit(); } }
    return changed;
  }
  checkHost(view:import1.AppView<any>,componentView:import1.AppView<any>,el:any,throwOnChange:boolean):void {
  }
  handleEvent(eventName:string,$event:any):boolean {
    var result:boolean = true;
    return result;
  }
  subscribe(view:import1.AppView<any>,_eventHandler:any):void {
    this._eventHandler = _eventHandler;
  }
}
var renderType_AuditComponent_Host:import2.RenderComponentType = import3.createRenderComponentType('',0,import4.ViewEncapsulation.None,([] as any[]),{});
class View_AuditComponent_Host0 extends import1.AppView<any> {
  _el_0:any;
  compView_0:import1.AppView<import0.AuditComponent>;
  _AuditService_0_3:import5.AuditService;
  _AuditComponent_0_4:Wrapper_AuditComponent;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any) {
    super(View_AuditComponent_Host0,renderType_AuditComponent_Host,import6.ViewType.HOST,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.selectOrCreateRenderHostElement(this.renderer,'audit-a2',import3.EMPTY_INLINE_ARRAY,rootSelector,(null as any));
    this.compView_0 = new View_AuditComponent0(this.viewUtils,this,0,this._el_0);
    this._AuditService_0_3 = new import5.AuditService(this.injectorGet(import9.Http,this.parentIndex));
    this._AuditComponent_0_4 = new Wrapper_AuditComponent(this._AuditService_0_3,this.injectorGet(import10.TranslateService,this.parentIndex));
    this.compView_0.create(this._AuditComponent_0_4.context);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [this._el_0]),(null as any));
    return new import8.ComponentRef_<any>(0,this,this._el_0,this._AuditComponent_0_4.context);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import5.AuditService) && (0 === requestNodeIndex))) { return this._AuditService_0_3; }
    if (((token === import0.AuditComponent) && (0 === requestNodeIndex))) { return this._AuditComponent_0_4.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    this._AuditComponent_0_4.ngDoCheck(this,this._el_0,throwOnChange);
    this.compView_0.internalDetectChanges(throwOnChange);
  }
  destroyInternal():void {
    this.compView_0.destroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
export const AuditComponentNgFactory:import8.ComponentFactory<import0.AuditComponent> = new import8.ComponentFactory<import0.AuditComponent>('audit-a2',View_AuditComponent_Host0,import0.AuditComponent);
const styles_AuditComponent:any[] = ([] as any[]);
class View_AuditComponent1 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  compView_2:import1.AppView<import11.AuditFilterComponent>;
  _AuditFilterComponent_2_3:import12.Wrapper_AuditFilterComponent;
  _text_3:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import13.ViewContainer) {
    super(View_AuditComponent1,renderType_AuditComponent,import6.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'div',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                    ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'audit-filter',import3.EMPTY_INLINE_ARRAY,(null as any));
    this.compView_2 = new import12.View_AuditFilterComponent0(this.viewUtils,this,2,this._el_2);
    this._AuditFilterComponent_2_3 = new import12.Wrapper_AuditFilterComponent();
    this.compView_2.create(this._AuditFilterComponent_2_3.context);
    this._text_3 = this.renderer.createText(this._el_0,'\n                ',(null as any));
    var disposable_0:Function = import3.subscribeToRenderElement(this,this._el_2,new import3.InlineArray4(4,'filter',(null as any),'export',(null as any)),this.eventHandler(this.handleEvent_2));
    this._AuditFilterComponent_2_3.subscribe(this,this.eventHandler(this.handleEvent_2),true,true);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3
    ]
    ),[disposable_0]);
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import11.AuditFilterComponent) && (2 === requestNodeIndex))) { return this._AuditFilterComponent_2_3.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_2_0_0:any = this.parentView.context.actions;
    this._AuditFilterComponent_2_3.check_actions(currVal_2_0_0,throwOnChange,false);
    this._AuditFilterComponent_2_3.ngDoCheck(this,this._el_2,throwOnChange);
    this.compView_2.internalDetectChanges(throwOnChange);
  }
  destroyInternal():void {
    this.compView_2.destroy();
    this._AuditFilterComponent_2_3.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
  handleEvent_2(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'filter')) {
      const pd_sub_0:any = ((<any>this.parentView.context.filterAudit($event)) !== false);
      result = (pd_sub_0 && result);
    }
    if ((eventName == 'export')) {
      const pd_sub_1:any = ((<any>this.parentView.context.exportAudit($event)) !== false);
      result = (pd_sub_1 && result);
    }
    return result;
  }
}
class View_AuditComponent2 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  compView_2:import1.AppView<import14.AuditListComponent>;
  _AuditListComponent_2_3:import15.Wrapper_AuditListComponent;
  _text_3:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import13.ViewContainer) {
    super(View_AuditComponent2,renderType_AuditComponent,import6.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'div',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                    ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'audit-list',import3.EMPTY_INLINE_ARRAY,(null as any));
    this.compView_2 = new import15.View_AuditListComponent0(this.viewUtils,this,2,this._el_2);
    this._AuditListComponent_2_3 = new import15.Wrapper_AuditListComponent();
    this.compView_2.create(this._AuditListComponent_2_3.context);
    this._text_3 = this.renderer.createText(this._el_0,'\n                ',(null as any));
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3
    ]
    ),(null as any));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import14.AuditListComponent) && (2 === requestNodeIndex))) { return this._AuditListComponent_2_3.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_2_0_0:any = this.parentView.context.audit;
    this._AuditListComponent_2_3.check_data(currVal_2_0_0,throwOnChange,false);
    this._AuditListComponent_2_3.ngDoCheck(this,this._el_2,throwOnChange);
    this.compView_2.internalDetectChanges(throwOnChange);
  }
  destroyInternal():void {
    this.compView_2.destroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
var renderType_AuditComponent:import2.RenderComponentType = import3.createRenderComponentType('',0,import4.ViewEncapsulation.None,styles_AuditComponent,{});
export class View_AuditComponent0 extends import1.AppView<import0.AuditComponent> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _el_4:any;
  _text_5:any;
  _el_6:any;
  _text_7:any;
  _el_8:any;
  _text_9:any;
  _el_10:any;
  _text_11:any;
  _el_12:any;
  _text_13:any;
  _text_14:any;
  _text_15:any;
  _text_16:any;
  _anchor_17:any;
  /*private*/ _vc_17:import13.ViewContainer;
  _TemplateRef_17_5:any;
  _NgIf_17_6:import16.Wrapper_NgIf;
  _text_18:any;
  _anchor_19:any;
  /*private*/ _vc_19:import13.ViewContainer;
  _TemplateRef_19_5:any;
  _NgIf_19_6:import16.Wrapper_NgIf;
  _text_20:any;
  _text_21:any;
  _text_22:any;
  _text_23:any;
  _text_24:any;
  /*private*/ _expr_31:any;
  _pipe_translate_0:import17.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any) {
    super(View_AuditComponent0,renderType_AuditComponent,import6.ViewType.COMPONENT,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways);
    this._expr_31 = import18.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    const parentRenderNode:any = this.renderer.createViewRoot(this.parentElement);
    this._el_0 = import3.createRenderElement(this.renderer,parentRenderNode,'div',new import3.InlineArray2(2,'class','eva-slide -up -start'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n    ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'div',new import3.InlineArray2(2,'class','container-fluid whitesmoke-section'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'\n        ',(null as any));
    this._el_4 = import3.createRenderElement(this.renderer,this._el_2,'div',new import3.InlineArray2(2,'class','eva-container'),(null as any));
    this._text_5 = this.renderer.createText(this._el_4,'\n            ',(null as any));
    this._el_6 = import3.createRenderElement(this.renderer,this._el_4,'div',new import3.InlineArray2(2,'class','eva-grid'),(null as any));
    this._text_7 = this.renderer.createText(this._el_6,'\n                ',(null as any));
    this._el_8 = import3.createRenderElement(this.renderer,this._el_6,'div',new import3.InlineArray2(2,'class','eva-row -m-top-lg'),(null as any));
    this._text_9 = this.renderer.createText(this._el_8,'\n                    ',(null as any));
    this._el_10 = import3.createRenderElement(this.renderer,this._el_8,'div',new import3.InlineArray2(2,'class','-md-12'),(null as any));
    this._text_11 = this.renderer.createText(this._el_10,'\n                        ',(null as any));
    this._el_12 = import3.createRenderElement(this.renderer,this._el_10,'span',new import3.InlineArray2(2,'class','-h1'),(null as any));
    this._text_13 = this.renderer.createText(this._el_12,'',(null as any));
    this._text_14 = this.renderer.createText(this._el_10,'\n                    ',(null as any));
    this._text_15 = this.renderer.createText(this._el_8,'\n                ',(null as any));
    this._text_16 = this.renderer.createText(this._el_6,'\n                ',(null as any));
    this._anchor_17 = this.renderer.createTemplateAnchor(this._el_6,(null as any));
    this._vc_17 = new import13.ViewContainer(17,6,this,this._anchor_17);
    this._TemplateRef_17_5 = new import19.TemplateRef_(this,17,this._anchor_17);
    this._NgIf_17_6 = new import16.Wrapper_NgIf(this._vc_17.vcRef,this._TemplateRef_17_5);
    this._text_18 = this.renderer.createText(this._el_6,'\n                ',(null as any));
    this._anchor_19 = this.renderer.createTemplateAnchor(this._el_6,(null as any));
    this._vc_19 = new import13.ViewContainer(19,6,this,this._anchor_19);
    this._TemplateRef_19_5 = new import19.TemplateRef_(this,19,this._anchor_19);
    this._NgIf_19_6 = new import16.Wrapper_NgIf(this._vc_19.vcRef,this._TemplateRef_19_5);
    this._text_20 = this.renderer.createText(this._el_6,'\n            ',(null as any));
    this._text_21 = this.renderer.createText(this._el_4,'\n        ',(null as any));
    this._text_22 = this.renderer.createText(this._el_2,'\n    ',(null as any));
    this._text_23 = this.renderer.createText(this._el_0,'\n',(null as any));
    this._text_24 = this.renderer.createText(parentRenderNode,'\n',(null as any));
    this._pipe_translate_0 = new import17.TranslatePipe(this.parentView.injectorGet(import10.TranslateService,this.parentIndex),this.ref);
    this.init((null as any),((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._el_4,
      this._text_5,
      this._el_6,
      this._text_7,
      this._el_8,
      this._text_9,
      this._el_10,
      this._text_11,
      this._el_12,
      this._text_13,
      this._text_14,
      this._text_15,
      this._text_16,
      this._anchor_17,
      this._text_18,
      this._anchor_19,
      this._text_20,
      this._text_21,
      this._text_22,
      this._text_23,
      this._text_24
    ]
    ),(null as any));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import19.TemplateRef) && (17 === requestNodeIndex))) { return this._TemplateRef_17_5; }
    if (((token === import20.NgIf) && (17 === requestNodeIndex))) { return this._NgIf_17_6.context; }
    if (((token === import19.TemplateRef) && (19 === requestNodeIndex))) { return this._TemplateRef_19_5; }
    if (((token === import20.NgIf) && (19 === requestNodeIndex))) { return this._NgIf_19_6.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import18.ValueUnwrapper();
    const currVal_17_0_0:any = this.context.actions;
    this._NgIf_17_6.check_ngIf(currVal_17_0_0,throwOnChange,false);
    this._NgIf_17_6.ngDoCheck(this,this._anchor_17,throwOnChange);
    const currVal_19_0_0:any = this.context.audit;
    this._NgIf_19_6.check_ngIf(currVal_19_0_0,throwOnChange,false);
    this._NgIf_19_6.ngDoCheck(this,this._anchor_19,throwOnChange);
    this._vc_17.detectChangesInNestedViews(throwOnChange);
    this._vc_19.detectChangesInNestedViews(throwOnChange);
    valUnwrapper.reset();
    const currVal_31:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_0.transform('audit.TITLE')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_31,currVal_31))) {
      this.renderer.setText(this._text_13,currVal_31);
      this._expr_31 = currVal_31;
    }
  }
  destroyInternal():void {
    this._vc_17.destroyNestedViews();
    this._vc_19.destroyNestedViews();
    this._pipe_translate_0.ngOnDestroy();
  }
  createEmbeddedViewInternal(nodeIndex:number):import1.AppView<any> {
    if ((nodeIndex == 17)) { return new View_AuditComponent1(this.viewUtils,this,17,this._anchor_17,this._vc_17); }
    if ((nodeIndex == 19)) { return new View_AuditComponent2(this.viewUtils,this,19,this._anchor_19,this._vc_19); }
    return (null as any);
  }
}


// WEBPACK FOOTER //
// ./aot/public/upgrade/feature/audit/audit.component.ngfactory.ts